"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const TooltipContainer = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.neutral.dark};
  padding: 10px;
  font-size: 12px;
  width: fit-content;
  border-radius: 8px;
  color: ${({ theme }) => theme.white};
  border: solid 1px ${({ theme }) => theme.neutral.dark};
  position: relative;

  &::before {
    content: "";
    border: solid 1px ${({ theme }) => theme.neutral.dark};
    background-color: ${({ theme }) => theme.neutral.dark};
    border-radius: 2px;
    position: absolute;
    left: 50%;
    top: -5px;
    width: 10px;
    height: 10px;
    transform: translateX(-50%) rotate(45deg);
    z-index: -1;
  }
  &::after {
    content: "";
    background-color: ${({ theme }) => theme.neutral.dark};
    border-radius: 2px;
    position: absolute;
    left: 50%;
    top: -4px;
    width: 9px;
    height: 9px;
    transform: translateX(-50%) rotate(45deg);
  }
`;
const RotaTooltip = (_a) => {
    var { tooltipText = "" } = _a, props = __rest(_a, ["tooltipText"]);
    return react_1.default.createElement(TooltipContainer, Object.assign({}, props), tooltipText);
};
exports.default = RotaTooltip;
